var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "route-box user-help-person" }, [
    _c(
      "div",
      { staticClass: "ev-page-return" },
      [
        _c("router-link", { attrs: { to: { path: "setting" } } }, [
          _c("span", { staticClass: "el-icon-arrow-left" }),
          _vm._v("返回 ")
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "userContent user-main" }, [
      _c("ul", { staticClass: "userNav" }, [
        _c(
          "li",
          {
            class: { navActive: _vm.navActive == 1 },
            on: {
              click: function($event) {
                return _vm.changeMenu(1)
              }
            }
          },
          [_c("span", [_vm._v("  常见问题")])]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: { navActive: _vm.navActive == 2 },
            on: {
              click: function($event) {
                return _vm.changeMenu(2)
              }
            }
          },
          [_c("span", [_vm._v("  指导手册")])]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "userDetail" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "el-collapse",
            {
              attrs: { accordion: "" },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c(
                "el-collapse-item",
                { attrs: { title: "1.如何创建学期信息？", name: "1" } },
                [
                  _c("div", { staticStyle: { "text-indent": "2em" } }, [
                    _vm._v(
                      "\n            学期信息由省级管理员统一创建，需要根据实际情况谨慎设置。一个学年分为秋季学期（即上学期）和春季学期（即下学期），秋季学期和春季学期需交替设置，设置完成后点击［完毕］方可下发到下级区域和学校。\n          "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-collapse-item",
                { attrs: { title: "2.如何维护人员信息？", name: "2" } },
                [
                  _c("div", { staticStyle: { "text-indent": "2em" } }, [
                    _vm._v(
                      "\n            在［人员信息］下，可以单个新增人员；也可以下载表格批量导入人员；如果发现人员信息有误，可以修改；如果人员不再使用系统可以停用；如果人员忘记密码，可以进行重置密码，重置为123456。\n          "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-collapse-item",
                { attrs: { title: "3.如何修改密码？", name: "3" } },
                [
                  _c("div", { staticStyle: { "text-indent": "2em" } }, [
                    _vm._v(
                      "\n            点击右上角的头像，在［个人中心］菜单下［修改密码］中，可以修改密码。\n          "
                    )
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          "margin-bottom": "20px",
          "font-size": "20px",
          "font-weight": "800"
        }
      },
      [_c("span", [_vm._v("常见问题")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }